import { createAsyncThunk } from '@reduxjs/toolkit';

import type { NegociacaoFlowLogs } from '../../types/flowLogs';
import { flowLogsService } from './services';

export const fetchFlowLogs = createAsyncThunk<NegociacaoFlowLogs, string, { rejectValue: string }>(
  'flowLogs/fetch',
  async (casoId, { rejectWithValue }) => {
    try {
      return await flowLogsService.getByCaso(casoId);
    } catch (error) {
      return rejectWithValue(error instanceof Error ? error.message : 'Erro ao carregar logs');
    }
  },
);
